export function isReunionTimezone(): boolean {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone === 'Indian/Reunion'
  } catch {
    return false
  }
}
